import { getArticle } from '@/config/articles';
import { business } from '@/config/business';
import { seoMeta } from '@/config/seoMeta';

export type RouteSeoEntry = { title: string; description: string };

/** Freshness stamp for non-article sitemap URLs; bump it when page content changes. */
export const SITE_LASTMOD = '2026-09-29';

export const fallbackSeo: RouteSeoEntry = seoMeta['/'];

export const notFoundSeo: RouteSeoEntry = {
  title: `Page not found (404) | ${business.brandName}`,
  description: `We couldn't find that page. Return to the ${business.brandName} home page to find what you were looking for.`,
};

export function normalizePathname(pathname: string): string {
  if (!pathname) return '/';
  const trimmed = pathname.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
}

export function resolveSeo(pathname: string): RouteSeoEntry {
  return seoMeta[normalizePathname(pathname)] ?? fallbackSeo;
}

export function isNotFoundPath(pathname: string): boolean {
  return seoMeta[normalizePathname(pathname)] === undefined;
}

/** Sitemap order: "/" first, then alphabetical. */
export function getAllSitemapPaths(): string[] {
  return Object.keys(seoMeta).sort((a, b) => (a === '/' ? -1 : b === '/' ? 1 : a.localeCompare(b)));
}

/** `<lastmod>` for a sitemap path: an article's dateModified, else SITE_LASTMOD. */
export function sitemapLastmod(path: string): string {
  return getArticle(normalizePathname(path))?.dateModified ?? SITE_LASTMOD;
}
